// @flow
import client from '../../client'
import format from '../../utils/format'

// Constants
export const GBT_UNLINK_ENDPOINT = '/corporate/gbt/mozio-gbt-link/{0}/'

/**
 * Unlink a Mozio reservation with a gbt trip
 * @param {string} reservation_hashed_id the mozio reservation id
 * @param {string} confirmation_number the mozio confirmation number for the reservation
 * @return {Promise|Error} A resolved Promise or Rejected with an Error
 */
export const gbtUnlink = (data: {
  reservation_hashed_id: string,
  confirmation_number: string,
}): Promise<any> => {
  const endpoint = format(GBT_UNLINK_ENDPOINT, data.confirmation_number)
  return client.delete(endpoint, {
    body: { reservation_hashed_id: data.reservation_hashed_id },
  })
}

export default gbtUnlink
